export const maxFontSize = 10
